export const environment = {
  currentEnvironment: 'live',
  apiUrl: '/api',
  apiPortalUrl: '/api-portal',
};
